'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'bus';
var width = 576;
var height = 512;
var aliases = [128653];
var unicode = 'f207';
var svgPathData = 'M80 83.7L80 96l416 0 0-12.3C482.5 61.9 430.7 16 288 16c-68 0-117.4 12.1-151.3 26.9C104.3 57 86.6 73.4 80 83.7zM80 256l200 0 0-144L80 112l0 144zm216 0l200 0 0-144-200 0 0 144zM80 432l16 0 16 0 64 0 16 0 178.3 0 13.7 0 16 0 64 0 16 0 16 0 0-160L80 272l0 160zm304 16l-13.7 0L192 448l0 48 0 16-16 0-64 0-16 0 0-16 0-48-24 0-8 0 0-8L64 81.5l0-2.1 1-1.8c8-14.4 29.3-33.7 65.2-49.4C166.5 12.4 218.1 0 288 0C437.6 0 495.3 49.6 511 77.6l1 1.8 0 2.1L512 440l0 8-8 0-24 0 0 48 0 16-16 0-64 0-16 0 0-16 0-48zm80 0l-64 0 0 48 64 0 0-48zm-352 0l0 48 64 0 0-48-64 0zm8-96a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 48l128 0 8 0 0 16-8 0L224 64l-8 0 0-16 8 0zM0 112l8 0 24 0 8 0 0 16-8 0-16 0 0 128 16 0 8 0 0 16-8 0L8 272l-8 0 0-8L0 120l0-8zm568 0l8 0 0 8 0 144 0 8-8 0-24 0-8 0 0-16 8 0 16 0 0-128-16 0-8 0 0-16 8 0 24 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;